import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import './ImageUploader.css';

const ImageUploader = ({ onImagesUpload, images, disabled }) => {
  const onDrop = useCallback((acceptedFiles) => {
    const imageFiles = acceptedFiles.filter(file => 
      file.type.startsWith('image/')
    );
    
    if (imageFiles.length > 0) {
      const filesWithPreview = imageFiles.map(file => ({
        file,
        preview: URL.createObjectURL(file),
        name: file.name
      }));
      onImagesUpload(filesWithPreview);
    }
  }, [onImagesUpload]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.tiff', '.bmp', '.webp']
    },
    disabled,
    multiple: true
  });

  const removeImage = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    onImagesUpload(newImages);
  };

  return (
    <div className="uploader-section">
      <div 
        {...getRootProps()} 
        className={`dropzone ${isDragActive ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
      >
        <input {...getInputProps()} />
        <div className="dropzone-content">
          <div className="upload-icon">📷</div>
          {isDragActive ? (
            <p>Drop the images here...</p>
          ) : (
            <>
              <p>Drag & drop Chandla Book pages here</p>
              <p>or click to select files</p>
              <p className="supported-formats">
                Supported: JPG, PNG, TIFF, BMP, WebP
              </p>
            </>
          )}
        </div>
      </div>

      {images.length > 0 && (
        <div className="image-previews">
          <h3>Selected Images ({images.length})</h3>
          <div className="preview-grid">
            {images.map((image, index) => (
              <div key={index} className="preview-item">
                <img 
                  src={image.preview} 
                  alt={`Preview ${index + 1}`}
                  className="preview-image"
                />
                <div className="preview-info">
                  <span className="preview-name">{image.name}</span>
                  <span className="preview-page">Page {index + 1}</span>
                </div>
                {!disabled && (
                  <button 
                    className="remove-btn"
                    onClick={() => removeImage(index)}
                  >
                    ×
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUploader;